var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container offset-md-3 col-md-6 pt-5 pb-5" },
    [
      !_vm.success
        ? _c(
            "div",
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "plan mb-2" }, [
                _vm._v("\n      プラン: \n      "),
                _vm.plan === "standard"
                  ? _c("span", [
                      _vm._v("\n        スタンダード\n        "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-outline-secondary",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.plan = "free"
                            }
                          }
                        },
                        [_vm._v("無料トライアルはこちら")]
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n        無料トライアル(ユーザ制限1人)\n        "
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-outline-primary",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.plan = "standard"
                            }
                          }
                        },
                        [_vm._v("スタンダードプランはこちら")]
                      )
                    ])
              ]),
              _vm._v(" "),
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.createToken()
                    }
                  }
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.companyName,
                          expression: "postData.companyName"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: "組織名 (例: アスニピース株式会社)",
                        required: ""
                      },
                      domProps: { value: _vm.postData.companyName },
                      on: {
                        focus: function($event) {
                          _vm.onFocus = "company"
                        },
                        blur: function($event) {
                          _vm.onFocus = ""
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "companyName",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.onFocus === "company" && _vm.postData.companyName
                      ? _c("label", { attrs: { for: "company-name" } }, [
                          _vm._v("組織名")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.onFocus !== "company" && _vm.postData.companyName
                      ? _c("label", { staticClass: "text-success ml-2" }, [
                          _c("i", { staticClass: "fas fa-check" })
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.userName,
                          expression: "postData.userName"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: "あなたの氏名",
                        required: ""
                      },
                      domProps: { value: _vm.postData.userName },
                      on: {
                        focus: function($event) {
                          _vm.onFocus = "name"
                        },
                        blur: function($event) {
                          _vm.onFocus = ""
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "userName",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.onFocus === "name" && _vm.postData.userName
                      ? _c("label", [_vm._v("あなたの氏名")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.onFocus !== "name" && _vm.postData.userName
                      ? _c("label", { staticClass: "text-success ml-2" }, [
                          _c("i", { staticClass: "fas fa-check" })
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.mail,
                          expression: "postData.mail"
                        }
                      ],
                      staticClass: "form-control",
                      class: {
                        "border-danger":
                          _vm.invalidMail ||
                          _vm.alreadyMail ||
                          _vm.invalidDomain
                      },
                      attrs: {
                        type: "mail",
                        placeholder: "メールアドレス",
                        required: ""
                      },
                      domProps: { value: _vm.postData.mail },
                      on: {
                        focus: function($event) {
                          _vm.onFocus = "mail"
                        },
                        blur: function($event) {
                          _vm.onFocus = ""
                        },
                        change: _vm.checkMailExists,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.postData, "mail", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.onFocus === "mail" && _vm.postData.mail
                      ? _c("label", { attrs: { for: "admin-mail" } }, [
                          _vm._v("メールアドレス")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.onFocus !== "mail" &&
                    _vm.postData.mail &&
                    !_vm.alreadyMail &&
                    !_vm.invalidDomain &&
                    !_vm.invalidMail
                      ? _c("label", { staticClass: "text-success ml-2" }, [
                          _c("i", { staticClass: "fas fa-check" })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.invalidMail
                      ? _c("span", { staticClass: "text-danger" }, [
                          _vm._v("正しいメールアドレスを入力ください")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.alreadyMail || _vm.invalidDomain
                      ? _c("span", { staticClass: "text-danger" }, [
                          _vm._v("既に登録されているドメインです")
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.plan === "standard"
                    ? _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("card", {
                            staticClass: "stripe-card form-control",
                            class: { complete: _vm.complete },
                            attrs: {
                              stripe: "pk_test_ATB0BR6wa6qxRztqsPZbSzrH",
                              options: _vm.stripeOptions
                            },
                            on: {
                              change: function($event) {
                                _vm.complete = $event.complete
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "text-align": "center" } }, [
                    _vm.plan === "standard"
                      ? _c("input", {
                          staticClass: "btn btn-primary",
                          attrs: {
                            type: "submit",
                            value: "スタンダードプランの開始",
                            disabled:
                              !_vm.complete ||
                              _vm.alreadyMail || _vm.invalidDomain
                          }
                        })
                      : _c("input", {
                          staticClass: "btn btn-primary",
                          attrs: {
                            type: "submit",
                            value: "無料で試す",
                            disabled:
                              !_vm.postData.companyName ||
                              !_vm.postData.userName ||
                              !_vm.postData.mail ||
                              _vm.alreadyMail || _vm.invalidDomain
                          }
                        })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("router-link", { attrs: { to: "/login" } }, [
                _vm._v("ログインページはこちら")
              ])
            ],
            1
          )
        : _c(
            "div",
            [
              _vm._v(
                "\n    登録されたメールアドレス宛にパスワードを送信しました。\n    "
              ),
              _c("router-link", { attrs: { to: "/login" } }, [
                _vm._v("ログインページはこちら")
              ])
            ],
            1
          )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header text-center" }, [
      _c("h1", { staticClass: "title" }, [
        _c("img", { attrs: { src: require("../../../img/logo.png") } })
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("アカウントを作成しましょう")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88fd7954", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88fd7954","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/common/SignUp.vue
// module id = 360
// module chunks = 0